import { Field, FieldFooter, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import CertificationPicker, {
  type ICertificationPickerProps,
} from 'components/domain/certification/CertificationPicker/CertificationPicker';
import { AnyObject } from 'types/util/Object';

export interface ICertificationPickerFormFieldProps<FormType extends AnyObject>
  extends Omit<ICertificationPickerProps, 'value' | 'onSelect'>,
    IFormFieldDefaultProps<string | null, FormType> {
  onSelect?: (value: string | null) => void;
}

const CertificationPickerFormField = <FormType extends AnyObject>({
  form,
  name,
  validations,
  onSelect,
  className,
  revalidateOnNewValidations,
  ...other
}: ICertificationPickerFormFieldProps<FormType>) => {
  function renderField({ ...fieldProps }) {
    function handleOnSelect(value: string | null) {
      fieldProps.handleChange(value, onSelect);
    }

    return (
      <>
        <CertificationPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  const classes = classNames('certification-picker-form-field', className);

  return (
    <Field
      className={classes}
      form={form}
      name={name}
      validations={validations}
      render={renderField}
      revalidateOnNewValidations={revalidateOnNewValidations}
    />
  );
};

export default CertificationPickerFormField;
